import React, { useState, useEffect } from 'react';
import { UserSettingsService } from '../api';
import { toast } from 'react-toastify';
import './ClubSettings.css';

function ClubSettings() {
  const [visibilityRangeKm, setVisibilityRangeKm] = useState(80);
  const [initialValue, setInitialValue] = useState(80);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    UserSettingsService.getCurrentUserProfile()
      .then(profile => {
        const value = profile.visibilityRangeKm ?? 80;
        setVisibilityRangeKm(value);
        setInitialValue(value);
      })
      .catch(() => {
        toast.error('Nie udało się pobrać ustawień');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    if (visibilityRangeKm < 1 || visibilityRangeKm > 500) {
      toast.error('Zasięg musi być w zakresie 1-500 km');
      return;
    }
    setSaving(true);
    try {
      await UserSettingsService.updateVisibilityRange(visibilityRangeKm);
      setInitialValue(visibilityRangeKm);
      toast.success('Zasięg widoczności został zapisany');
    } catch {
      toast.error('Nie udało się zapisać ustawienia');
    } finally {
      setSaving(false);
    }
  };

  const hasChanged = visibilityRangeKm !== initialValue;

  if (loading) {
    return <div className="club-settings-loading">Ładowanie ustawień...</div>;
  }

  return (
    <div className="club-settings">
      <div className="club-settings-section">
        <h3 className="club-settings-title">Zasięg widoczności</h3>
        <p className="club-settings-description">
          Określ maksymalną odległość (w km), z jakiej inne kluby mogą zobaczyć Twoje drużyny
          w wynikach wyszukiwania. Kluby znajdujące się dalej niż podana wartość nie zobaczą
          Twoich drużyn.
        </p>
        <div className="club-settings-control">
          <div className="club-settings-input-row">
            <input
              type="range"
              min={1}
              max={500}
              value={visibilityRangeKm}
              onChange={e => setVisibilityRangeKm(Number(e.target.value))}
              className="club-settings-slider"
            />
            <div className="club-settings-value-wrapper">
              <input
                type="number"
                min={1}
                max={500}
                value={visibilityRangeKm}
                onChange={e => {
                  const val = Number(e.target.value);
                  if (val >= 1 && val <= 500) {
                    setVisibilityRangeKm(val);
                  } else if (e.target.value === '') {
                    setVisibilityRangeKm(1);
                  }
                }}
                className="club-settings-number-input"
              />
              <span className="club-settings-unit">km</span>
            </div>
          </div>
          <div className="club-settings-range-labels">
            <span>1 km</span>
            <span>500 km</span>
          </div>
        </div>
        <button
          onClick={handleSave}
          disabled={saving || !hasChanged}
          className="btn btn-primary club-settings-save"
        >
          {saving ? 'Zapisywanie...' : 'Zapisz'}
        </button>
      </div>
    </div>
  );
}

export default ClubSettings;
